/**
 * Removes all falsy values from the array
 * and dedupes the array
 * */
export function sanitizeEmailArray(
  emails: Array<string | null | undefined>,
): string[] {
  const cleaned = emails
    .filter((email): email is string => typeof email === "string")
    .map((email) => email.trim().toLowerCase())
    .filter((email) => email !== "");

  return Array.from(new Set(cleaned));
}
